import React from "react";
import { View } from "react-native";
import { theme } from "@clearabee/ui-library-native";
import { useTrainContext } from "./Train.utils";
import type { TrainItemIconProps } from "./Train.types";

export const TrainItemIcon = ({
  icon,
}: TrainItemIconProps): React.ReactElement => {
  const {
    position: { current },
  } = useTrainContext();

  return (
    <View
      style={[
        {
          borderRadius: 100,
          padding: theme.spacing.small,
          backgroundColor: theme.colors.greyscale.lightest,
        },
        current.active &&
          !current.last && {
            backgroundColor: theme.colors.light.base,
            borderWidth: 3,
            padding: theme.spacing.small - 3,
            borderColor: theme.colors.positive.base,
          },
        current.active &&
          (current.first || current.last) && {
            backgroundColor: theme.colors.positive.base,
          },
        current.complete &&
          !current.last && {
            backgroundColor: theme.colors.positive.lighter,
          },
      ]}
    >
      {icon}
    </View>
  );
};
